import { render, staticRenderFns } from "./TicimaxChannelDashboard.vue?vue&type=template&id=cdba1f22&scoped=true"
import script from "./TicimaxChannelDashboard.vue?vue&type=script&lang=js"
export * from "./TicimaxChannelDashboard.vue?vue&type=script&lang=js"
import style0 from "./TicimaxChannelDashboard.vue?vue&type=style&index=0&id=cdba1f22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdba1f22",
  null
  
)

export default component.exports